import { createContext, useContext, useEffect, useState } from "react";
import api, { ensureViewToken, clearViewToken } from "@/lib/api";
import { clientInfo, clearGateToken } from "@/lib/clientInfo";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ge_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ge_token");
    if (!token) {
      setLoading(false);
      return;
    }
    ensureViewToken();
    const t = setInterval(() => ensureViewToken(), 60 * 60 * 1000);   // görüntüleme jetonu saatte bir tazelenir (12 sa ömür)
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("ge_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("ge_token");
        localStorage.removeItem("ge_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
    return () => clearInterval(t);
  }, []);

  const finishLogin = async (data) => {
    localStorage.setItem("ge_token", data.token);
    localStorage.setItem("ge_user", JSON.stringify(data.user));
    clearGateToken();   // giriş parolası tek kullanımlık: çıkışta / yeni açılışta tekrar sorulur
    await ensureViewToken(true);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password, client: await clientInfo() });
    return finishLogin(data);
  };

  const pinLogin = async (userId, pin) => {
    const { data } = await api.post("/auth/pin-login", { user_id: userId, pin, client: await clientInfo() });
    return finishLogin(data);
  };

  const userLogin = async (userId, password) => {
    const { data } = await api.post("/auth/user-login", { user_id: userId, password, client: await clientInfo() });
    return finishLogin(data);
  };

  const logout = () => {
    localStorage.removeItem("ge_token");
    localStorage.removeItem("ge_user");
    clearViewToken();
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, pinLogin, userLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
